import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-464590bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bargain_share_div" }
const _hoisted_2 = { class: "conetent_div" }
const _hoisted_3 = { class: "banner" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Bargain ")
const _hoisted_6 = { class: "user_goods_div" }
const _hoisted_7 = { class: "user_div" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "user_desc" }
const _hoisted_10 = { class: "goods_img_div" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "goods_desc_div" }
const _hoisted_13 = { class: "goods_name" }
const _hoisted_14 = { class: "goods_price" }
const _hoisted_15 = { class: "goods_old_price" }
const _hoisted_16 = {
  key: 0,
  class: "goods_time_div"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time_label_div" }, "Ends in", -1))
const _hoisted_18 = { class: "time_content_div" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_21 = {
  key: 1,
  class: "progress_div"
}
const _hoisted_22 = { class: "bargain_price_div" }
const _hoisted_23 = { class: "bargained_div" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Bargained: ")
const _hoisted_25 = { class: "remaining_div" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Remaining: ")
const _hoisted_27 = { class: "btn_div" }
const _hoisted_28 = {
  key: 0,
  class: "bargain_records_div"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title_div" }, " Bargain Records ", -1))
const _hoisted_30 = { class: "records__div" }
const _hoisted_31 = { class: "item_icon" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "item_phone" }
const _hoisted_34 = { class: "item_price_div" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Bargained ")
const _hoisted_36 = {
  key: 1,
  class: "import_height"
}

import { ref, inject, computed, onMounted } from 'vue';
import { Toast } from 'vant'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'BargainShare',
  setup(__props) {

const $http: any = inject("$http");
const route = useRoute()
const router = useRouter()
const $store: any = inject("$store");
const currencyUnit: String = $store.getSymbol()

let records_index = ref(0)
let bargain_records_list = ref([])
let is_no_transform = ref(false)

const get_scroll_top = computed(() => {
  if(bargain_records_list.value.length < 3) return 0
  return records_index.value * 100 / bargain_records_list.value.length
})
const update_scroll_top_fn = () => {
 
  if(get_scroll_top.value >= 50) { 
    setTimeout(() => {
      is_no_transform.value = true
      records_index.value = 0
    }, 500);
  }

  setTimeout(() => {
    is_no_transform.value = false
    records_index.value ++
    update_scroll_top_fn()

  }, 2000);

  
}
update_scroll_top_fn()

const shareCode = route.query.code
let bargain_info: any = ref('')
const leaveAmount = computed(() => {
  return  (bargain_info.value.goodsPrice - bargain_info.value.hasCutTotalAmount).toFixed(2)
})
let time_ms = ref(0)
const time_h = computed(() => {
  return Math.floor(time_ms.value / 3600)
})
const time_m = computed(() => {
  return Math.floor(time_ms.value / 60) - time_h.value * 60
})
const time_s = computed(() => {
  return time_ms.value - time_h.value * 3600 - time_m.value * 60
})
let progress_num =  ref(0)
const get_progress = computed(() => {
  return progress_num.value
})

const btn_click_fn = () => {
  let query = route.query
  let deeplink = `kiliapp://kilimall?type=${query.type}&siteCode=${query.sitecode}&data=${query.code}&regid=${query.regid}`
  let url = `https://app.adjust.com/${query.adcode}?deeplink=${encodeURIComponent(deeplink)}`
  window.location.href = url
}


let state = ref(0)
let btn_name = ref('')

const get_share_content_fn = computed(() => {
  if(bargain_info.value === '') return ''
  if(bargain_info.value.bargainStatus === 1) {
    // 正常砍价中
    state.value = 1
    btn_name.value = 'Help bargain to free'
    return 'Please help me, I really need it You have a chance to get it after helping me!'
  } else if(bargain_info.value.bargainStatus == 4 || bargain_info.value.bargainStatus === 5 || bargain_info.value.bargainStatus === 6 ) { 
    // 砍价成功
    state.value = 2
    btn_name.value = 'Get it for free'
    return 'Thank you! I have got this item for free! '
  } else {
    // 砍价失败
    state.value = 3
    btn_name.value = 'Start a new bargain'
    return 'Sorry, this bargain has expired'
  }
})

const actv_bargain_rule_fn = () => {
  router.push({
    path:'/bargainrule' 
  })
}
const start_time_fn = () => {
  setTimeout(() => {
    time_ms.value --
    if(time_ms.value >= 1) {
      start_time_fn()
    }
    else {
      bargain_info.value.bargainStatus = 3
    }
  }, 1000);
}

const animat_fn = () => {
  let ltm = (bargain_info.value.hasCutTotalAmount / bargain_info.value.goodsPrice * 100)
  setTimeout(() => {
    progress_num.value = progress_num.value + 1
    if(progress_num.value < ltm) {
      animat_fn()
    }
    else {
      progress_num.value = ltm.toFixed(1)
    }
  }, 20);
}

const get_bargain_info_fn =  async() => {
  let param = {
    re_method: 'shareBargainToFriend',
    data: {
        shareCode: shareCode
    }
  }
  let formData = new FormData();
  formData.append('re_method','shareBargainToFriend')     
  formData.append('data', JSON.stringify(param.data))   
  await $http.get_nologin_post(formData).then((res:any) => {
    if (res.code === 200) {
      if(res.data.resultCode == 200){
        bargain_info.value = res.data.data
        time_ms.value = res.data.data.bargainCountdown
        // bargain_info.value.bargainStatus = 1
        if(time_ms.value < 0) time_ms.value = 0
        animat_fn()
        start_time_fn()
      }else{
        Toast({
          message: res.data.resultMsg,
          duration: 3000
        })
      }
       
    } else {
      Toast({
        message: res.message,
        duration: 3000
      })
    }
  })
}

const get_bargain_records_fn =  async() => {
 
  let formData = new FormData();
  formData.append('re_method','bargainRecordList')     
  formData.append('data', JSON.stringify({regId: route.query.regid}))   
  await $http.get_nologin_post(formData).then((res:any) => {
    if (res.code === 200) {
      if(res.data.resultCode == 200){
        // 双倍数据 不间断循环
        // res.data.data = []
        bargain_records_list.value = res.data.data
        if(bargain_records_list.value.length > 2) bargain_records_list.value = bargain_records_list.value.concat(res.data.data) 

      }else{
        Toast({
          message: res.data.resultMsg,
          duration: 3000
        })
      }
       
    } else {
      Toast({
        message: res.message,
        duration: 3000
      })
    }
  })
}
get_bargain_info_fn()
get_bargain_records_fn()
  
const img_error_fn = (event: Event) => {
  let e = event.target as HTMLImageElement
  e.src = "https://image.kilimall.com/global/images/avatar.png"
}

return (_ctx: any,_cache: any) => {
  const _component_van_progress = _resolveComponent("van-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src:  _unref(state) !== 3 ? 'https://image.kilimall.com/kenya/new_wap/bargain/bargain_header_y.png' : 'https://image.kilimall.com/kenya/new_wap/bargain/bargain_header_n.png'
        }, null, 8, _hoisted_4),
        _createElementVNode("div", { class: "header_div" }, [
          _hoisted_5,
          _createElementVNode("div", {
            onClick: actv_bargain_rule_fn,
            class: "rules_btn_div"
          }, "Rules")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            alt: "user_logo",
            onError: img_error_fn,
            src: _unref(bargain_info).shareImg ? _unref(bargain_info).shareImg : ' '
          }, null, 40, _hoisted_8),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(get_share_content_fn)), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["goods_div", _unref(state) === 3 ? 'failure_div' : '' ])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              alt: "goods_img",
              onError: img_error_fn,
              src: _unref(bargain_info).goodsListImg ? _unref(bargain_info).goodsListImg : ' '
            }, null, 40, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(bargain_info).goodsName), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(currencyUnit)) + " 0", 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(currencyUnit)) + " " + _toDisplayString(_unref(bargain_info).goodsPrice ? parseInt(_unref(bargain_info).goodsPrice).thousands() : ''), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["label_icon", {' label_icon_failure': _unref(state) === 3, 'label_icon_succeed': _unref(state) === 2 }])
          }, null, 2)
        ], 2),
        (_unref(bargain_info).bargainStatus === 1 && _unref(time_ms) > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(_unref(time_h) < 10 ? '0' + _unref(time_h) : _unref(time_h)), 1),
                _hoisted_19,
                _createElementVNode("span", null, _toDisplayString(_unref(time_m) < 10 ? '0' + _unref(time_m) : _unref(time_m)), 1),
                _hoisted_20,
                _createElementVNode("span", null, _toDisplayString(_unref(time_s) < 10 ? '0' + _unref(time_s) : _unref(time_s)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(state) === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_van_progress, {
                color: "linear-gradient(270deg, #F33C48 0%, #F8BF2A 100%)",
                "stroke-width": "10px",
                percentage: _unref(get_progress),
                "track-color": "#FFE9E2"
              }, null, 8, ["percentage"]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("span", null, _toDisplayString(_unref(currencyUnit)) + " " + _toDisplayString(_unref(bargain_info).hasCutTotalAmount), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("span", null, _toDisplayString(_unref(currencyUnit)) + " " + _toDisplayString(_unref(leaveAmount) > 0 ? _unref(leaveAmount): ''), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", {
            onClick: btn_click_fn,
            class: "button_btn"
          }, _toDisplayString(_unref(btn_name)), 1)
        ])
      ]),
      (_unref(bargain_records_list).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("ul", {
                style: _normalizeStyle('transform: translate3d(0,-' + _unref(get_scroll_top) + '%,0);'),
                class: _normalizeClass(["records_ul", _unref(is_no_transform) ? 'no_transform' : ''])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bargain_records_list), (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: 'record_'+ index,
                    class: "records_li"
                  }, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("img", {
                        src: item.userLogo,
                        onError: img_error_fn
                      }, null, 40, _hoisted_32)
                    ]),
                    _createElementVNode("div", _hoisted_33, _toDisplayString(item.userName ? item.userName.substr(0,3) + '***' + item.userName.substr(6) : ''), 1),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("span", null, _toDisplayString(_unref(currencyUnit)) + " " + _toDisplayString(item.cutPrice), 1)
                    ])
                  ]))
                }), 128))
              ], 6)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_36))
    ])
  ]))
}
}

})